import { Link } from 'react-router-dom';
import BackButton from '../../components/ui/atoms/BackButton';

const Imprint = () => (
  <div className="px-4 pb-28 pt-14 max-w-3xl mx-auto mt-10">
    <BackButton />
    <h1 className="text-2xl font-semibold mb-4">Imprint</h1>

    <p>
      <strong>PanPals</strong>
      <br />
      Operated by: Mohsen Nasiri (Einzelunternehmer)
      <br />
      Address: c/o Mailboxde.com GmbH<br />
      Äußere Weberstr. 57<br />
      02763 Zittau, Germany
      <br />
      Email:{' '}
      <Link 
        to="mailto:support@panpals.de"
        className="text-blue-600 underline hover:text-blue-800"
      >
        support@panpals.de
      </Link>
      
      <br />
      VAT ID (§27a UStG): Not applicable (Kleinunternehmer)
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">Disclaimer</h2>
    <p>
      Despite careful content control, we assume no liability for the content of external links. The operators of linked pages are solely responsible for their content.
    </p>
  </div>
);

export default Imprint;
